var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49866 28.3079C1.49866 13.5016 13.5016 1.49865 28.3079 1.49865C43.1143 1.49866 55.1172 13.5016 55.1172 28.3079C55.1172 43.1143 43.1143 55.1172 28.3079 55.1172C13.5016 55.1172 1.49866 43.1143 1.49866 28.3079Z",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6278 25.9846C45.5511 27.0951 45.5511 29.8712 43.6278 30.9816L28.4815 39.7264C26.5581 40.8368 24.1539 39.4488 24.1539 37.2279L24.1539 19.7383C24.1539 17.5175 26.5581 16.1295 28.4815 17.2398L43.6278 25.9846Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9453 31.7344L34.2622 31.7344C36.0547 31.7344 37.5078 30.2812 37.5078 28.4887C37.5078 26.6962 36.0547 25.2431 34.2622 25.2431L14.9453 25.2431C13.1528 25.2431 11.6997 26.6962 11.6997 28.4887C11.6997 30.2812 13.1528 31.7344 14.9453 31.7344Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.acc305515ddf38d76da0e0934310bcf8.svg";
export { ForwardRef as ReactComponent };